import { createContext } from "react";
import { getDefaultCurrency } from "./config";
import LocaleService, { getDefaultCurrency as getDefaultCurrencyLegacy } from "./LocaleService";
var CurrencyContext = createContext({
  get defaultCurrency() {
    return LocaleService.JUTRO_PRIVATE_NOT_USE_LOCALE_SERVICE ? getDefaultCurrency() : getDefaultCurrencyLegacy() || getDefaultCurrency();
  }
});
export var CurrencyContextProvider = CurrencyContext.Provider;
export var CurrencyContextConsumer = CurrencyContext.Consumer;
export default CurrencyContext;